import React, { useEffect, useMemo, useRef, useState } from 'react';
import PaginationComponent from '../../shared/components/PaginationComponent';
import AddEditCommanTasks from '../components/forms/AddEditCommanTasksTemplate';
import Modal from '../../shared/components/ui/Modal';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Button from '../../shared/components/ui/Button';
import FormInput from '../../shared/components/ui/FormInput';
import { Pencil, Trash, Plus, CirclePlus } from 'lucide-react';
import { SwipeableDrawer } from '@mui/material';
import InfiniteScroll from 'react-infinite-scroll-component';
import {
  getContractorAndArchitect,
  updateLiveTask,
  makePreviewFalse,
  getAllBlocks,
  createGroupLiveTasks,
  getAllGroupLiveTask,
  addAccGroupLiveTasks,
  updateAllTaskUsers,
  getAllWorkTypes,
  getUnitPricingByBlockId,
  updateAllGroupTaskSPs,
  deleteLiveTask,
  checkLiveTaskDelete,
  bulkDeleteLiveTask,
  getTaskTemplates,
  bulkCompleteTasks,
  assignUsersByCheckbox,
  cancelCreatedLiveTask
} from '../services/api/implementation/impl';
import { useMutation, useQuery, useInfiniteQuery } from '@tanstack/react-query';
import DP from '../../shared/assets/svg/noUser.svg';
import toast from 'react-hot-toast';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import noDataIcon from '../../shared/assets/svg/NoData.svg';
import { getUsers } from '../../super-admin/services/api/implementation/impl';
import TaskDetailsPage from './TaskDetailsPage';
import { useNavigate } from 'react-router-dom';
import CalenderIcon from '../../shared/assets/svg/calendar.svg';
import AddEditAccGroupTask from './AddEditAccGroupLiveTask';
import Loader from './../../shared/components/ui/Loader';
import Multiselect from 'multiselect-react-dropdown';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { setFormData } from '../../../uiSlice';
import DeleteConfirmationModal from '../components/ui/DeleteConfirmationModal';
import CustomLevelDropdown from '../components/ui/CustomLevelDropdown';
import CustomUnitDropdown from '../components/ui/CustomUnitDropdown';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import BulkCompleteModal from '../components/forms/BulkCompleteModal';
import TableData from '../../shared/components/ui/TableData';
import BulkEngineerAssignmentModal from '../components/layout/BulkEngineerAssignmentModal';
import BulkContractorAssignmentModal from '../components/layout/BulkContractorAssignmentModal';
import BulkActionModal from '../components/forms/BulkActionModal';
import { useProjectsList } from '../../../contexts/ProjectsContext';
import { AddServiceProvider } from '../components/forms/AddEditServiceProvider';
import { createServiceProvider } from '../services/api/implementation/impl';

const GroupLiveTasks = ({ setisLoading, aiPrefill = null }) => {
  const userId = Cookies.get('userId');
  const { projects, projectsForDropdown, isProjectsLoading } = useProjectsList();
  const dispatch = useDispatch();
  const storedFormData = useSelector((state) => state.ui.formData?.group || {});
  const validationSchema = yup.object().shape({
    project: yup.string().required('Select Project'),
    block: yup.string().required('Select Block') // Make unit optional (nullable)
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    control,
    watch,
    resetField
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      block: '' // Ensure block has a default value.
    }
  });
  const { collapsed } = useSidebar();
  const blockId = watch('block');
  const projectID = watch('project');
  const [isOpenAddEditModal, setIsOpenAddEditModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const [isDateModalOpen, setIsDateModalOpen] = useState(false);
  const [selectedDateType, setSelectedDateType] = useState(''); // 'start' or 'end'
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const [tempDate, setTempDate] = useState(null); // temp selected date
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalData, setModalData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [AllUsers, setAllUsers] = useState([]);
  const [AllContractors, setAllContractors] = useState([]);
  const [AllArchitect, setAllArchitect] = useState([]);
  const colors = ['bg-orange-400', 'bg-blue-500', 'bg-green-500', 'bg-purple-500']; // Add more if needed
  const [apiType, setApiType] = useState();
  const navigate = useNavigate();
  const [hidePreviewBtn, setHidePreviewBtn] = useState(false);
  const [hidePreviewTable, setHidePreviewTable] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [previousTask, setPreviousTask] = useState();
  const [unique, setUnique] = useState(false);
  const [allAssignedSPs, setAllAssignedSPs] = useState();
  const [userOptions, setUserOptions] = useState({});
  const selectedWorkType = watch('workType');
  const [taskPositionType, setTaskPositionType] = useState();
  const userColorMap = {};
  const [canDelete, setCanDelete] = useState(null);
  const [resData, setResData] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const [levels, setLevels] = useState();
  const [isBulk, setIsBulk] = useState(false);
  const [selectItems, setSelectItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isBulkCompleteModalOpen, setIsBulkCompleteModalOpen] = useState(false);

  // Engineer bulk assignment modal state
  const [isEngineerBulkAssignModalOpen, setIsEngineerBulkAssignModalOpen] = useState(false);
  // Contractor bulk assignment modal state
  const [isContractorBulkAssignModalOpen, setIsContractorBulkAssignModalOpen] = useState(false);
  // Bulk action modal state
  const [isBulkActionModalOpen, setIsBulkActionModalOpen] = useState(false);

  // Add Service Provider modal state
  const [showAddSPModal, setShowAddSPModal] = useState(false);
  const [isSubmittingSP, setIsSubmittingSP] = useState(false);

  // Mutation for creating service provider
  const { mutate: handleCreateServiceProvider } = useMutation({
    mutationFn: createServiceProvider,
    onMutate: () => {
      setIsSubmittingSP(true);
    },
    onSuccess: async (data) => {
      setIsSubmittingSP(false);
      toast.success('Service Provider created successfully');
      setShowAddSPModal(false);
      // Refetch contractors or architects based on modal title
      if (modalTitle === 'Select Contractors') {
        await ContractorsMutation();
      } else if (modalTitle === 'Select Architects') {
        await ArchitectsMutation();
      }
    },
    onError: (err) => {
      setIsSubmittingSP(false);
      toast.error(
        err?.response?.data?.message || err?.message || 'Error creating service provider'
      );
    }
  });

  // Infinite scroll state (simplified)
  const [allTasks, setAllTasks] = useState([]);
  const limit = 50; // Page size for infinite scroll

  function getUserColor(userId) {
    if (!userColorMap[userId]) {
      const keys = Object.keys(userColorMap);
      userColorMap[userId] = colors[keys.length % colors.length];
    }
    return userColorMap[userId];
  }

  const [AllUnits, setAllUnits] = useState([]);

  const { mutate: refetchUnits } = useMutation({
    mutationFn: () => getUnitPricingByBlockId(blockId),
    onMutate: () => {
      setIsSubmitting(true);
    },
    onSuccess: async (res) => {
      setAllUnits(res);
      setIsSubmitting(false);
    },
    onError: (err) => {
      setIsSubmitting(false);
      toast.error(err?.response?.data?.message || err?.message || 'Error fetching units');
    }
  });

  // Separate mutation for opening contractor modal with units data
  const { mutate: refetchUnitsAndOpenModal } = useMutation({
    mutationFn: () => getUnitPricingByBlockId(blockId),
    onMutate: () => {
      setIsSubmitting(true);
    },
    onSuccess: async (res) => {
      setAllUnits(res);
      setIsSubmitting(false);
      // Open the contractor modal after units data is fetched
      setIsContractorBulkAssignModalOpen(true);
    },
    onError: (err) => {
      setIsSubmitting(false);
      toast.error(err?.response?.data?.message || err?.message || 'Error fetching units');
    }
  });

  const { mutate: UsersMutation } = useMutation({
    mutationFn: () => getUsers(),
    onMutate: () => {
      setIsSubmitting(true);
    },
    onSuccess: async (res) => {
      setAllUsers(res);
      setIsSubmitting(false);

      // Process users immediately after setting state
      const usersArray = res?.data || res;
      const filteredUsers = usersArray
        .filter((user) => {
          return (
            user.vertical === 'Operations' &&
            Array.isArray(user.userProjectMapping) &&
            user.userProjectMapping.some(
              (mapping) => String(mapping.project_id) === String(projectID)
            )
          );
        })
        .map((user) => ({
          user: {
            id: user.id,
            name: user.name,
            level: user.level
          }
        }));

      setAllUsers(filteredUsers);
    },
    onError: (err) => {
      setIsSubmitting(false);
      toast.error(err?.response?.data?.message || err?.message || 'Error fetching users');
    }
  });

  const [AllWorkTypes, setAllWorkTypes] = useState([]);

  const { mutate: fetchWorkTypes } = useMutation({
    mutationFn: () => getAllWorkTypes(),
    onMutate: () => {
      setIsSubmitting(true);
    },
    onSuccess: async (res) => {
      setAllWorkTypes(res);
      setIsSubmitting(false);
    },
    onError: (err) => {
      setIsSubmitting(false);
      toast.error(err?.response?.data?.message || err?.message || 'Error fetching work types');
    }
  });

  const { data: TaskTemplates, refetch: refetchTaskTemplates } = useQuery({
    queryKey: ['getTaskTemplates', projectID],
    queryFn: () => getTaskTemplates(projectID, 'group'),
    enabled: !!projectID,
    refetchOnWindowFocus: true, // Refetch when user comes back to the page
    refetchOnMount: true // Refetch every time component mounts
  });

  // Refetch task templates when component mounts and project is available
  useEffect(() => {
    if (projectID) {
      refetchTaskTemplates();
    }
  }, [projectID, refetchTaskTemplates]);

  // Track page view
  useEffect(() => {
    mixpanel.track('Group Live Tasks Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  const { mutate: ContractorsMutation } = useMutation({
    mutationFn: () => getContractorAndArchitect(1),
    onMutate: () => {
      setIsSubmitting(true);
    },
    onSuccess: async (res) => {
      setAllContractors(res);
      setIsSubmitting(false);
    },
    onError: (err) => {
      setIsSubmitting(false);
      toast.error(err?.response?.data?.message || err?.message || 'Error fetching contractors');
    }
  });

  const { mutate: ArchitectsMutation } = useMutation({
    mutationFn: () => getContractorAndArchitect(2),
    onMutate: () => {
      setIsSubmitting(true);
    },
    onSuccess: async (res) => {
      setAllArchitect(res);
      setIsSubmitting(false);
    },
    onError: (err) => {
      setIsSubmitting(false);
      toast.error(err?.response?.data?.message || err?.message || 'Error fetching architects');
    }
  });

  // Handle modal data updates when AllUsers changes
  useEffect(() => {
    if (AllUsers && modalTitle === 'Select Engineers') {
      setModalData(AllUsers);

      // For column add button (bulk assignment), do smart pre-selection
      if (unique) {
        const smartSelectedEngineers = AllUsers.filter((engineer) => {
          const assignedTasks = tasks.filter((task) =>
            task?.engineerLiveTaskMapping?.some((eng) => eng.user?.id === engineer.user?.id)
          );
          return assignedTasks.length === tasks.length && tasks.length > 0;
        }).map((eng) => eng.user?.id);
        setSelectedItems(smartSelectedEngineers);
      }
    }
  }, [AllUsers, modalTitle, unique, tasks]);

  // Handle modal data updates when AllContractors changes
  useEffect(() => {
    if (AllContractors && modalTitle === 'Select Contractors') {
      setModalData(AllContractors?.data);

      // For column add button (bulk assignment), do smart pre-selection
      if (unique) {
        const smartSelectedContractors =
          AllContractors?.data
            ?.filter((contractor) => {
              const assignedTasks = tasks.filter((task) =>
                task?.spLiveTaskMapping?.some(
                  (sp) =>
                    sp?.user?.serviceProvider?.category_id === 1 &&
                    sp.user?.id === contractor.user?.id
                )
              );
              return assignedTasks.length === tasks.length && tasks.length > 0;
            })
            .map((contractor) => contractor.user?.id) || [];

        setSelectedItems(smartSelectedContractors);

        const allAssignedArchitectIds = tasks?.reduce((acc, task) => {
          const architectIds =
            task?.spLiveTaskMapping
              ?.filter((sp) => sp?.user?.serviceProvider?.category_id === 2)
              .map((sp) => sp.user?.id)
              .filter(Boolean) || [];
          return acc.concat(architectIds);
        }, []);
        setAllAssignedSPs([...new Set(allAssignedArchitectIds)]);
      }
    }
  }, [AllContractors, modalTitle, unique, tasks]);

  // Handle modal data updates when AllArchitect changes
  useEffect(() => {
    if (AllArchitect && modalTitle === 'Select Architects') {
      setModalData(AllArchitect?.data);

      // For column add button (bulk assignment), do smart pre-selection
      if (unique) {
        const smartSelectedArchitects =
          AllArchitect?.data
            ?.filter((architect) => {
              const assignedTasks = tasks.filter((task) =>
                task?.architectLiveTaskMapping?.some(
                  (sp) =>
                    sp?.user?.serviceProvider?.category_id === 2 &&
                    sp.user?.id === architect.user?.id
                )
              );
              return assignedTasks.length === tasks.length && tasks.length > 0;
            })
            .map((architect) => architect.user?.id) || [];

        setSelectedItems(smartSelectedArchitects);

        const allAssignedContractorIds = tasks?.reduce((acc, task) => {
          const architectIds =
            task?.architectLiveTaskMapping
              ?.filter((sp) => sp?.user?.serviceProvider?.category_id === 1)
              .map((sp) => sp.user?.id)
              .filter(Boolean) || [];
          return acc.concat(architectIds);
        }, []);
        setAllAssignedSPs([...new Set(allAssignedContractorIds)]);
      }
    }
  }, [AllArchitect, modalTitle, unique, tasks]);

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch: refetchGroupLiveTask,
    isFetching
  } = useInfiniteQuery({
    queryKey: ['getAllGroupLiveTask', blockId],
    queryFn: ({ pageParam = 1 }) => {
      if (!blockId) {
        return Promise.resolve({ data: [], meta: { total: 0, page: 1, limit: 50 } });
      }
      // return getAllGroupLiveTask(blockId, pageParam, limit);
      return getAllGroupLiveTask(blockId);
    },
    getNextPageParam: (lastPage) => {
      // Use meta data to determine if there's a next page
      const { meta } = lastPage || {};
      if (meta && meta.total && meta.page && meta.limit) {
        const totalPages = Math.ceil(meta.total / meta.limit);
        const nextPage = meta.page + 1;
        return nextPage <= totalPages ? nextPage : undefined;
      }
      return undefined;
    },
    enabled: !!blockId,
    initialPageParam: 1
  });

  useEffect(() => {
    setisLoading(isFetching);
  }, [isFetching]);

  useEffect(() => {
    if (data?.pages) {
      // Flatten all pages into a single array
      const allTasks = data.pages.flatMap((page) => page.data || []);
      setAllTasks(allTasks);
      setTasks(allTasks);

      const allAdded = allTasks?.length > 0 && allTasks?.every((task) => task?.isAdded);
      setHidePreviewBtn(allAdded);

      const isPreviewComplete = allTasks?.length > 0 && allTasks?.every((task) => !task?.preview);
      setHidePreviewTable(isPreviewComplete);
    }
  }, [data]);

  useEffect(() => {
    refetchGroupLiveTask();
  }, []);

  const loadMore = () => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  };

  const resetPagination = () => {
    // Reset the infinite query
    refetchGroupLiveTask();
  };

  const { data: AllBlocks, refetch: refetchBlocks } = useQuery({
    queryKey: ['getAllBlocks', projectID],
    queryFn: () => getAllBlocks(projectID),
    enabled: !!projectID
  });

  const transformedDataBlocks =
    (AllBlocks || [])
      .filter((item) => item?.type === 'Group')
      ?.map((item) => ({
        label: item.name || '',
        id: item.id,
        value: item.id,
        levels: item.levels?.map((level) => ({
          label: level.name || '',
          id: level.id,
          value: level.id
        }))
      }))
      .sort((a, b) => a.label.localeCompare(b.label)) || [];

  const transformedDataTaskTemplates =
    TaskTemplates?.map((item) => ({
      label: item.name || '',
      id: item.name,
      value: item.name
    })) || [];

  useEffect(() => {
    if (projects) {
      const preferred = aiPrefill?.projectId || projects?.[0]?.id;
      if (preferred) setValue('project', preferred);
    }
  }, [projects, aiPrefill?.projectId, setValue]);

  useEffect(() => {
    if (aiPrefill?.templateName) {
      setValue('template_name', aiPrefill.templateName);
    }
  }, [aiPrefill?.templateName, setValue]);

  const transformedDataWorkTypes =
    AllWorkTypes?.filter((item) => item.type === 'Accomodation') // ✅ filter first
      ?.map((item) => ({
        label: item.name || '',
        id: item.id,
        value: item.id
      })) || [];

  useEffect(() => {
    if (AllBlocks && AllBlocks.length > 0) {
      const firstGroupBlock = AllBlocks.find((item) => item?.type === 'Group');
      if (firstGroupBlock?.id) {
        setValue('block', firstGroupBlock?.id);
      } else {
        setValue('block', '');
      }
    }
  }, [AllBlocks, setValue]);

  const transformedDataUnits =
    AllUnits?.data
      ?.map((item) => ({
        label: item.unitName || '',
        id: item.id,
        value: item.id
      }))
      .sort((a, b) => a.label.localeCompare(b.label)) || [];

  const handleDateClick = (taskId, type) => {
    setSelectedTaskId(taskId);
    setSelectedDateType(type);
    setIsDateModalOpen(true);
  };

  const handleDateSubmit = () => {
    if (!tempDate || !selectedTaskId || !selectedDateType) return;

    const formattedDate = tempDate?.toLocaleDateString('en-CA');

    let payload = {}; // <-- changed from const to let
    if (selectedDateType === 'start') {
      payload = {
        planned_start_date: formattedDate
      };
    }

    if (selectedDateType === 'end') {
      payload = {
        planned_end_date: formattedDate
      };
    }

    updateTask({ selectedTaskId, payload });
    setIsDateModalOpen(false);
    setTempDate(null);
    setSelectedTaskId(null);
    setSelectedDateType('');
  };

  // Bulk completion handlers
  const handleBulkCompleteClick = () => {
    fetchWorkTypes();
    setIsBulkCompleteModalOpen(true);
  };

  const handleBulkCompleteSubmit = async (payload) => {
    try {
      // Add project_id to the payload
      const fullPayload = {
        task_ids: payload.taskIds
      };

      // Call bulk completion API
      await bulkCompleteTasks(fullPayload);

      toast.success(`${payload.taskIds.length} task(s) completed successfully`);
      setIsBulkCompleteModalOpen(false);
      resetPagination();
      await refetchGroupLiveTask();
    } catch (error) {
      console.error('Error completing tasks:', error);
      toast.error(error?.response?.data?.message || error?.message || 'Error completing tasks');
    }
  };

  const { mutate: updateTask } = useMutation({
    mutationFn: ({ selectedTaskId, payload }) => updateLiveTask(selectedTaskId, payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success('Task updated successfully');
      setUnique(false);
      resetField('workType');
      resetPagination();
      await refetchGroupLiveTask();
      setTaskPositionType();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error updating task', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error updating task');
    }
  });

  const toggleSelect = (userId) => {
    // Check if this is engineer selection and apply type restrictions
    if (modalTitle === 'Select Engineers') {
      const isSelected = selectedItems.some((item) => item.id === userId);

      if (!isSelected) {
        // Check if adding this engineer would exceed limits
        const user = modalData.find((u) => u.user?.id === userId);
        if (user && user.user?.level) {
          const selectedEngineers = modalData.filter((u) =>
            selectedItems.some((item) => item.id === u.user?.id)
          );
          const mediumLevelCount = selectedEngineers.filter(
            (u) => u.user?.level === 'Medium'
          ).length;
          const lowLevelCount = selectedEngineers.filter((u) => u.user?.level === 'Low').length;

          if (user.user.level === 'Medium' && mediumLevelCount >= 1) {
            console.log('Preventing Medium selection');
            toast.error('Only 1 Medium level engineer can be selected');
            return;
          }
          if (user.user.level === 'Low' && lowLevelCount >= 1) {
            console.log('Preventing Low selection');
            toast.error('Only 1 Low level engineer can be selected');
            return;
          }
        }
      }
    }

    const isSelected = selectedItems.some((item) => item.id === userId);
    if (isSelected) {
      setSelectedItems(selectedItems.filter((item) => item.id !== userId));
      const updatedOptions = { ...userOptions };
      delete updatedOptions[userId];
      setUserOptions(updatedOptions);
    } else {
      setSelectedItems([...selectedItems, { id: userId }]);
      setUserOptions({
        ...userOptions,
        [userId]: {}
      });
    }
  };

  const { mutate: updateTaskUsers } = useMutation({
    mutationFn: (payload) => updateAllTaskUsers(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success('Task updated successfully');
      setUnique(false);
      resetField('workType');
      resetPagination();
      await refetchGroupLiveTask();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error updating task', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error updating task');
    }
  });

  const { mutate: updateTaskSPs } = useMutation({
    mutationFn: (payload) => updateAllGroupTaskSPs(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success('Task updated successfully');
      setUnique(false);
      resetPagination();
      await refetchGroupLiveTask();
      resetField('workType');
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error updating task', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error updating task');
    }
  });

  const getFormattedSelectedUsers = () => {
    return selectedItems.reduce((acc, item) => {
      const userId = item.id;
      const workTypeId = item.workType_id;
      const userOption = userOptions[userId];

      if (!userOption) return acc;

      const baseData = {
        id: Number(userId),
        block_id: blockId,
        workType_id: Number(workTypeId || selectedWorkType) // Fallback to selectedWorkType if not in item
      };

      // Create separate objects for each true type
      if (userOption.externalType) {
        acc.push({
          ...baseData,
          levelType: 'external'
        });
      }

      if (userOption?.levelType && userOption?.level_ids?.length > 0) {
        acc.push({
          ...baseData,
          levelType: 'levelWise',
          level_ids: userOption?.level_ids?.map(Number)
        });
      }

      if (userOption.unitType && userOption?.unit_ids?.length > 0) {
        acc.push({
          ...baseData,
          levelType: 'unitWise',
          unit_ids: userOption?.unit_ids?.map(Number)
        });
      }

      return acc;
    }, []);
  };

  const handleAddClick = () => {
    if (unique && modalTitle === 'Select Contractors') {
      if (!selectedWorkType || selectedWorkType === '') {
        toast.error('Select WorkType');
        return;
      }
    }
    const formattedData = getFormattedSelectedUsers();

    let payload = {}; // <-- changed from const to let
    if (modalTitle === 'Select Contractors' || modalTitle === 'Select Architects') {
      const SPids = [...new Set([...selectedItems.map((item) => item.id), ...allAssignedSPs])];

      const matchingIds = formattedData?.filter(
        (item) => item.workType_id === Number(selectedWorkType)
      );

      if (unique && modalTitle === 'Select Contractors') {
        payload = {
          sp_ids: matchingIds
        };
      } else {
        if (modalTitle === 'Select Contractors') {
          payload = {
            sp_ids: SPids,
            taskType: 'Group',
            block_id: Number(blockId)
          };
        }

        if (modalTitle === 'Select Architects') {
          payload = {
            architect_ids: SPids,
            taskType: 'Group',
            block_id: Number(blockId)
          };
        }
      }
    }

    if (modalTitle === 'Select Engineers') {
      const selectedEngineers = modalData.filter((u) =>
        selectedItems.some((s) => s.id === u.user?.id)
      );

      const mediumLevelCount = selectedEngineers.filter((u) => u.user?.level === 'Medium').length;
      const lowLevelCount = selectedEngineers.filter((u) => u.user?.level === 'Low').length;

      if (mediumLevelCount !== 1) {
        toast.error('Please select exactly one Manager');
        return;
      }
      if (lowLevelCount !== 1) {
        toast.error('Please select exactly one Executive');
        return;
      }

      payload = {
        engineer_ids: selectedItems?.map((item) => item.id),
        taskType: 'Group',
        block_id: Number(blockId)
      };
    }

    console.log('Payload', payload);

    if (unique) {
      if (modalTitle === 'Select Engineers' || modalTitle === 'Select Architects') {
        updateTaskUsers(payload);
      }
      if (modalTitle === 'Select Contractors') {
        updateTaskSPs(payload);
      }
    }
    if (!unique) {
      updateTask({ selectedTaskId, payload });
    }
    setModalOpen(false);
    setUserOptions({});
  };

  const handleImageClick = (id, type) => {
    setSelectedTaskId(id); // Set the currently focused task ID

    // Find the task data to get assigned users
    const currentTask = tasks.find((task) => task?.id === id);

    let currentlyAssignedIds = [];

    if (currentTask) {
      if (type === 'engineer') {
        setModalTitle('Select Engineers');
        UsersMutation();
        currentlyAssignedIds =
          currentTask.engineerLiveTaskMapping?.map((eng) => ({
            id: eng.user?.id,
            workType_id: currentTask.workType_id
          })) || [];
      } else if (type === 'contractor') {
        setModalTitle('Select Contractors');
        ContractorsMutation();
        currentlyAssignedIds =
          currentTask?.spLiveTaskMapping
            ?.filter((sp) => sp?.user?.serviceProvider?.category_id === 1)
            ?.map((sp) => ({
              id: sp.user?.id,
              workType_id: currentTask.workType_id
            })) || [];
        const allids =
          currentTask?.spLiveTaskMapping
            ?.filter((sp) => sp?.user?.serviceProvider?.category_id === 2)
            ?.map((sp) => sp.user?.id) || [];
        setAllAssignedSPs(allids);
      } else if (type === 'architect') {
        setModalTitle('Select Architects');
        ArchitectsMutation();
        currentlyAssignedIds =
          currentTask?.architectLiveTaskMapping
            ?.filter((sp) => sp?.user?.serviceProvider?.category_id === 2)
            ?.map((sp) => ({
              id: sp.user?.id,
              workType_id: currentTask.workType_id
            })) || [];
        const allids =
          currentTask?.architectLiveTaskMapping
            ?.filter((sp) => sp?.user?.serviceProvider?.category_id === 1)
            ?.map((sp) => sp.user?.id) || [];
        setAllAssignedSPs(allids);
      }
      setSelectedItems(currentlyAssignedIds);
    } else if (id === null && type === 'engineer') {
      // Handle the case for adding engineers to all tasks (CirclePlus button)
      setModalTitle('Select Engineers');
      UsersMutation();
      setUnique(true);
    } else if (id === null && type === 'contractor') {
      // Handle the case for adding contractors to all tasks (CirclePlus button)
      fetchWorkTypes(); // Call getAllWorkTypes when architect is clicked
      refetchUnits(); // Call getUnitPricingByBlockId when contractor is clicked

      setModalTitle('Select Contractors');
      ContractorsMutation();
      setUnique(true);
    } else if (id === null && type === 'architect') {
      // Handle the case for adding architects to all tasks (CirclePlus button)
      setModalTitle('Select Architects');
      ArchitectsMutation();
      setUnique(true);
    } else {
      // Reset if task not found or for other types if needed
      setModalTitle(`Select ${type.charAt(0).toUpperCase() + type.slice(1)}s`);
      UsersMutation();
      ContractorsMutation();
      ArchitectsMutation();
      setModalData([]);
      setSelectedItems([]);
    }

    setModalOpen(true);
  };

  const HandleCreate = (data) => {
    if (!watch('template_name')) {
      toast.error('Please select task template');
      return;
    }
    const payload = {
      block_id: Number(data.block),
      name: watch('template_name'),
      sections: Number(data.sections)
    };
    createIndependentLive(payload);
  };

  const { mutate: createIndependentLive } = useMutation({
    mutationFn: (payload) => createGroupLiveTasks(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success('Tasks created successfully');
      resetPagination();
      await refetchGroupLiveTask();
      setTaskPositionType();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error creating new tasks', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error creating tasks');
    }
  });

  useEffect(() => {
    console.log(errors);
  }, [errors]);

  const { mutate: savePreview } = useMutation({
    mutationFn: (payload) => makePreviewFalse(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      resetPagination();
      await refetchGroupLiveTask();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error saving preview', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error saving preview');
    }
  });

  const { mutate: cancelCreatedLiveTaskFn } = useMutation({
    mutationFn: (payload) => cancelCreatedLiveTask(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      resetPagination();
      await refetchGroupLiveTask();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error canceling created live task', err);
      toast.error(
        err?.response?.data?.message || err?.message || 'Error canceling created live task'
      );
    }
  });

  const formatDate = (dateString) => {
    if (!dateString) return null;

    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' }); // May, Jun, etc.
    const year = date.getFullYear();

    // Add "st", "nd", "rd", "th"
    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return 'th'; // 11th, 12th, 13th
      switch (n % 10) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    };

    return `${day}${getOrdinal(day)} ${month} ${year}`;
  };

  const [state, setState] = useState({
    right: false
  });

  const toggleDrawer = (anchor, open) => {
    setState((prevState) => ({ ...prevState, [anchor]: open }));
  };

  const HandleSavePreview = () => {
    const payload = {
      taskType: 'Group',
      block_id: Number(watch('block'))
    };
    savePreview(payload);
  };

  const HandleCancelCreatedLiveTask = () => {
    const payload = {
      taskType: 'Group',
      block_id: Number(watch('block'))
    };
    cancelCreatedLiveTaskFn(payload);
  };

  const handleAddTask = (data) => {
    const payload = {
      ...data,
      prevTask_id: previousTask?.id,
      block_id: Number(blockId)
    };
    AddAccGroupLive(payload);
  };

  const { mutate: AddAccGroupLive } = useMutation({
    mutationFn: (payload) =>
      modalType === 'Add'
        ? addAccGroupLiveTasks(payload)
        : updateLiveTask(previousTask?.id, payload),
    onMutate: () => {
      setisLoading(true);
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      setIsOpenAddEditModal(false);
      toast.success(`Tasks ${modalType === 'Add' ? 'created' : 'updated'} successfully`);
      resetPagination();
      await refetchGroupLiveTask();
      setisLoading(false);
      setTaskPositionType();
    },
    onError: (err) => {
      setIsSubmitting(false);
      setisLoading(false);
      console.error(`Error ${modalType === 'Add' ? 'creating new' : 'updating'}  task`, err);
      toast.error(
        err?.response?.data?.message ||
        err?.message ||
        `Error ${modalType === 'Add' ? 'creating new' : 'updating'} task`
      );
    }
  });

  const handleOnEdit = (id) => {
    const task = tasks.find((item) => item.id === Number(id)); // Use find() instead of filter()
    if (task) {
      setIsOpenAddEditModal(true);
      setModalType('Edit');
      setPreviousTask(task);
    }
  };

  useEffect(() => {
    setisLoading(isSubmitting);
  }, [isSubmitting]);

  function formatTasksByWorkType(tasks) {
    const grouped = {};

    tasks.forEach((task) => {
      const workTypeName = task?.workType?.name;
      if (!grouped[workTypeName]) {
        grouped[workTypeName] = [];
      }
      grouped[workTypeName].push(task);
    });

    const formatted = [];

    for (const [workType, taskList] of Object.entries(grouped)) {
      const [first, ...rest] = taskList;

      const formattedGroup = {
        id: first.id,
        workType: workType,
        workType_id: first.workType_id,
        planned_end_date: first.planned_end_date,
        planned_start_date: first.planned_start_date,
        actual_end_date: first.actual_end_date,
        actual_start_date: first.actual_start_date,
        status: first.status,
        name: first.name,
        delay: `${first.delay} day${first.delay > 1 ? 's' : ''}`,
        Others: rest?.map((task, i) => ({
          id: task?.id,
          workType: workType,
          workType_id: task.workType_id,
          planned_end_date: task.planned_end_date,
          planned_start_date: task.planned_start_date,
          actual_end_date: task.actual_end_date,
          actual_start_date: task.actual_start_date,
          status: task.status,
          name: task.name,
          delay: `${task.delay} day${task.delay > 1 ? 's' : ''}`
        }))
      };

      formatted.push(formattedGroup);
    }

    return formatted;
  }

  const formatted = useMemo(() => formatTasksByWorkType(tasks), [tasks]);

  useEffect(() => {
    if (projectID) {
      dispatch(
        setFormData({
          subTab: 'group',
          data: { projectID }
        })
      );
    }
  }, [projectID]);

  useEffect(() => {
    if (blockId) {
      dispatch(
        setFormData({
          subTab: 'group',
          data: { blockId }
        })
      );
    }
  }, [blockId]);

  useEffect(() => {
    if (!projects?.length) return; // wait for both to be fetched

    if (storedFormData.projectID) {
      setValue('project', storedFormData.projectID);
    }
  }, [projects]);

  useEffect(() => {
    if (!AllBlocks?.length) return; // wait for both to be fetched

    if (storedFormData.blockId) {
      setValue('unit', storedFormData.blockId);
    }
  }, [AllBlocks]);

  //delete functions

  const { mutate: handleCheckDelete } = useMutation({
    mutationFn: (id) => checkLiveTaskDelete(id),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (res, id) => {
      setIsSubmitting(false);
      const task = tasks?.find((item) => parseInt(item.id) === parseInt(id));
      const taskName = task?.name || 'Task';
      if (res.canDelete) {
        setCanDelete('yes');
        setResData({ name: taskName });
        setSelectedIds([parseInt(id)]);
      } else {
        // Fallback if not found
        setResData({ ...res, name: taskName });
        setCanDelete('no');
      }
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error checking dependencies', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error checking dependencies');
    }
  });

  const { mutate: handleDeleteFn } = useMutation({
    mutationFn: (payload) => deleteLiveTask(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: () => {
      setIsSubmitting(false);
      toast.success('Task Deleted Successfully');
      resetPagination();
      refetchGroupLiveTask();
      setCanDelete(null);
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error deleting task', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error deleting task');
    }
  });

  const HandleDelete = (data) => {
    const payload = { ids: data };
    handleDeleteFn(payload);
  };

  useEffect(() => {
    const selectedBlock = transformedDataBlocks.find((block) => block.id === Number(blockId));
    if (selectedBlock) {
      setLevels(selectedBlock.levels || []);
    } else {
      setLevels([]);
    }
  }, [blockId]);

  const calculateDelay = (task) => {
    if (!task.planned_end_date) return '---';

    const plannedEnd = new Date(task.planned_end_date);
    const today = new Date();

    let delay;

    if (task.status === 'To Do' || task.status === 'In Progress') {
      delay = Math.floor((today - plannedEnd) / (1000 * 60 * 60 * 24)); // days
    } else if (task.status === 'Completed') {
      if (!task.actual_end_date) return '---';
      const actualEnd = new Date(task.actual_end_date);
      delay = Math.floor((actualEnd - plannedEnd) / (1000 * 60 * 60 * 24)); // days
    } else {
      return '---';
    }

    return delay > 0 ? `${delay} days` : '---';
  };

  const { mutate: handleBulkDeleteFn } = useMutation({
    mutationFn: (payload) => bulkDeleteLiveTask(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: () => {
      setIsSubmitting(false);
      toast.success('Task Deleted Successfully');
      resetPagination();
      refetchGroupLiveTask();
      setCanDelete(null);
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error deleting task', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error deleting task');
    }
  });

  const handleSelectAll = async (e) => {
    const checked = e.target.checked;
    if (checked) {
      const results = tasks?.map((item) => item.id);
      setSelectItems(results);
    } else {
      setSelectItems([]);
    }
  };

  // Engineer bulk assignment handler
  const handleBulkEngineerAssignment = async ({
    selectedTasks,
    selectedEngineers,
    selectedWorkType
  }) => {
    const payload = {
      taskIds: selectedTasks,
      engineer_ids: selectedEngineers
    };

    try {
      console.log('Bulk Engineer Assignment Payload:', payload);
      await assignUsersByCheckbox(payload);

      // Small delay to ensure backend processes the changes
      await new Promise((resolve) => setTimeout(resolve, 500));

      toast.success('Engineers assigned successfully');

      // Track success
      mixpanel.track('Bulk Engineer Assignment', {
        user_id: userId,
        task_count: selectedTasks.length,
        engineer_count: selectedEngineers.length,
        work_type: selectedWorkType
      });
      setIsEngineerBulkAssignModalOpen(false);
      resetPagination();
      await refetchGroupLiveTask();
    } catch (error) {
      console.error('Error assigning engineers:', error);
      toast.error(error?.response?.data?.message || error?.message || 'Error assigning engineers');

      // Track error
      mixpanel.track('Bulk Engineer Assignment Error', {
        user_id: userId,
        error: error.message
      });
    }
  };

  // Contractor bulk assignment handler
  const handleBulkContractorAssignment = async ({
    selectedTasks,
    selectedContractors,
    selectedWorkType,
    formattedData
  }) => {
    try {
      console.log('Bulk Contractor Assignment Payload:', {
        selectedTasks,
        selectedContractors,
        selectedWorkType,
        formattedData
      });

      const data = formattedData?.map((item) => ({ ...item, block_id: blockId }));
      // Use the same payload structure as the old handleAddClick for bulk contractors
      const payload = {
        sp_ids: data
      };

      await updateTaskSPs(payload);

      // Small delay to ensure backend processes the changes
      await new Promise((resolve) => setTimeout(resolve, 500));

      toast.success('Contractors assigned successfully');

      // Track success
      mixpanel.track('Bulk Contractor Assignment', {
        user_id: userId,
        task_count: selectedTasks.length,
        contractor_count: selectedContractors.length,
        work_type: selectedWorkType
      });
      setIsContractorBulkAssignModalOpen(false);
      resetPagination();
      await refetchGroupLiveTask();
    } catch (error) {
      console.error('Error assigning contractors:', error);
      toast.error(
        error?.response?.data?.message || error?.message || 'Error assigning contractors'
      );

      // Track error
      mixpanel.track('Bulk Contractor Assignment Error', {
        user_id: userId,
        error: error.message
      });
    }
  };

  const HandleBulkDelete = () => {
    const payload = { taskType: 'Group', block_id: blockId };
    handleBulkDeleteFn(payload);
  };

  return (
    <div className="mt-[8rem] relative">
      {isOpenAddEditModal && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={65}
          name={modalType === 'Edit' ? 'Edit Task' : 'Add Task'}
          onClose={() => setIsOpenAddEditModal(false)}>
          <AddEditAccGroupTask
            isSubmitting={isSubmitting}
            onSubmit={handleAddTask}
            onClose={() => setIsOpenAddEditModal(false)}
            modalType={modalType}
            setModalType={setModalType}
            blockId={blockId}
            tasks={tasks}
            selectedTask={previousTask}
            taskPositionType={taskPositionType}
          />
        </Modal>
      )}

      {modalOpen && (
        <Modal
          isDirty={true}
          width={40}
          name={modalTitle}
          onClose={() => {
            setModalOpen(false);
            resetField('workType');
            setUserOptions({});
          }}>
          <div>
            {unique && modalTitle === 'Select Contractors' && (
              <FormInput
                width={48}
                label={'Work Type'}
                register={register}
                register_key={'workType'}
                isRequired={true}
                type={'dropdown'}
                options={[
                  { label: 'Select Worktype', value: '', disabled: true, selected: true },
                  ...transformedDataWorkTypes
                ]}
              />
            )}

            <div className="modal-body max-h-[300px] overflow-y-auto mt-4">
              {modalTitle === 'Select Engineers' && (
                <div className="mb-2 text-sm font-medium text-gray-600 bg-blue-50 p-2 rounded">
                  Required: 1 Manager + 1 Executive
                </div>
              )}
              {modalData && modalData.length > 0 ? (
                modalData?.map((item) => {
                  const userId = item.user?.id;
                  const isSelected =
                    unique && modalTitle === 'Select Contractors'
                      ? selectedItems.some(
                        (selected) =>
                          selected.id === userId &&
                          selected.workType_id === Number(selectedWorkType)
                      )
                      : // For others: simple ID check
                      selectedItems.some((selected) => selected.id === userId);

                  // Check if this engineer should be disabled
                  let isDisabled = false;
                  if (modalTitle === 'Select Engineers' && !isSelected) {
                    const selectedEngineers = modalData.filter((u) =>
                      selectedItems.some((selected) => selected.id === u.user?.id)
                    );
                    const mediumLevelCount = selectedEngineers.filter(
                      (u) => u.user?.level === 'Medium'
                    ).length;
                    const lowLevelCount = selectedEngineers.filter(
                      (u) => u.user?.level === 'Low'
                    ).length;

                    if (item.user?.level === 'Medium' && mediumLevelCount >= 1) {
                      isDisabled = true;
                    }
                    if (item.user?.level === 'Low' && lowLevelCount >= 1) {
                      isDisabled = true;
                    }
                  }

                  const initials = item.user?.name
                    ?.split(' ')
                    ?.map((word) => word[0])
                    ?.join('')
                    ?.toUpperCase();
                  const workTypeName = AllWorkTypes?.find(
                    (item) => item.id === Number(selectedWorkType)
                  );
                  return (
                    <div key={item.id || userId} className="flex mb-3 flex-col">
                      <div
                        onClick={() => {
                          if (isDisabled) return;

                          if (modalTitle === 'Select Engineers') {
                            // Use toggleSelect for engineers to apply type restrictions
                            toggleSelect(userId);
                          } else if (unique && modalTitle === 'Select Contractors') {
                            if (!selectedWorkType || selectedWorkType === '') {
                              toast.error('Please select Worktype');
                              return;
                            }

                            const userId = item.user?.id;
                            const workTypeId = Number(selectedWorkType);

                            // Toggle selection
                            setSelectedItems((prev) => {
                              const exists = prev.some(
                                (i) => i.id === userId && i.workType_id === workTypeId
                              );
                              return exists
                                ? prev.filter(
                                  (i) => !(i.id === userId && i.workType_id === workTypeId)
                                )
                                : [...prev, { id: userId, workType_id: workTypeId }];
                            });

                            // Initialize userOptions for this user if not exists
                            setUserOptions((prev) => ({
                              ...prev,
                              [userId]: prev[userId] || {
                                level_ids: [],
                                unit_ids: [],
                                externalType: false,
                                levelType: false,
                                unitType: false
                              }
                            }));
                          } else {
                            // Original logic for non-contractor selection
                            setSelectedItems((prev) => {
                              const exists = prev.some((i) => i.id === userId);
                              return exists
                                ? prev.filter((i) => i.id !== userId)
                                : [...prev, { id: userId }];
                            });
                          }
                        }}
                        className={`flex items-center gap-3 p-3 ${isSelected ? 'rounded-t-lg' : 'rounded-lg'
                          } ${isSelected
                            ? 'cursor-pointer'
                            : isDisabled
                              ? 'cursor-not-allowed opacity-50'
                              : 'cursor-pointer'
                          } border ${isSelected
                            ? 'bg-green-100'
                            : isDisabled
                              ? 'bg-gray-100'
                              : 'bg-white hover:bg-gray-50'
                          }`}>
                        <div
                          className={`w-8 h-8 rounded-full text-white flex items-center justify-center font-semibold text-sm ${getUserColor(
                            userId
                          )}`}>
                          {initials}
                        </div>
                        <div className="flex-1">
                          <span className="text-gray-800 capitalize">{item.user?.name}</span>
                          {modalTitle === 'Select Engineers' && item.user?.level && (
                            <span className="ml-2 text-sm text-gray-500">
                              ({item.user.level === 'Medium' ? 'Manager' : 'Executive'})
                            </span>
                          )}
                        </div>
                        {isDisabled && (
                          <div className="text-xs text-gray-400">
                            {item.user?.level === 'Medium' ? 'Max 1 Medium' : 'Max 1 Low'}
                          </div>
                        )}
                      </div>

                      {isSelected && modalTitle === 'Select Contractors' && unique && (
                        <div className="flex border gap-3 justify-start items-center flex-wrap p-3 rounded-b-lg">
                          {/* Common Space Dropdown */}
                          <div className="flex flex-col w-[48%]">
                            <CustomLevelDropdown
                              userId={userId}
                              userOptions={userOptions}
                              setUserOptions={setUserOptions}
                              levels={levels}
                            />
                          </div>

                          {/* Unit Selection */}
                          {workTypeName &&
                            workTypeName.name !== 'Structural Work' &&
                            workTypeName.name !== 'Brick Work' &&
                            workTypeName.name !== 'Plaster Work' && (
                              <div className="flex flex-col w-[48%]">
                                <CustomUnitDropdown
                                  userId={userId}
                                  userOptions={userOptions}
                                  setUserOptions={setUserOptions}
                                  units={transformedDataUnits}
                                />
                              </div>
                            )}
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                <p className="text-center text-gray-500">No users to display</p>
              )}
            </div>
          </div>

          {modalData && modalData.length > 0 && (
            <div className="flex gap-2 mt-5 justify-between items-center">
              {(modalTitle === 'Select Contractors' || modalTitle === 'Select Architects') && (
                <button
                  onClick={() => setShowAddSPModal(true)}
                  className="text-blue-500 hover:text-blue-700 text-sm font-semibold underline cursor-pointer">
                  Add
                </button>
              )}
              <div className="flex gap-2 ml-auto">
                <Button
                  customStyle={{ width: '7rem' }}
                  displayType={'secondary'}
                  onClick={() => {
                    setModalOpen(false);
                    setModalData([]);
                  }}>
                  Close
                </Button>
                <Button customStyle={{ width: '7rem' }} onClick={handleAddClick}>
                  Add
                </Button>
              </div>
            </div>
          )}
        </Modal>
      )}

      {isDateModalOpen && (
        <div className="h-screen w-screen bg-[#0000002a] z-[90] flex justify-center items-center fixed top-0 left-0">
          <div className="flex flex-col items-center p-1  bg-white rounded-lg">
            <DatePicker selected={tempDate} onChange={(date) => setTempDate(date)} inline />

            <div className="flex gap-4 mt-3 w-[100%] justify-end">
              <Button
                type="button"
                onClick={() => setIsDateModalOpen(false)}
                displayType="secondary">
                Cancel
              </Button>

              <Button type="button" onClick={() => handleDateSubmit()} disabled={!tempDate}>
                OK
              </Button>
            </div>
          </div>
        </div>
      )}

      {canDelete === 'no' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={`Cannot delete '${resData?.name || 'this task'}'`}
          onClose={() => {
            setCanDelete(null);
            setIsBulk(false);
            setSelectItems([]);
          }}
          width={45}>
          <div className="flex flex-col justify-center align-center ">
            <p className="text-center">
              Looks like this task has dependencies, please delete following task to proceed
            </p>
            <div className="flex justify-start, align-middle flex-wrap bg-[#f5f7f8] p-2 rounded-[5px] mt-4">
              {resData &&
                resData.reason?.map((r, index) => (
                  <span className="mt-[2px] mr-[4px] text-[#535353]" key={index}>
                    {index + 1}.{r}
                    {index < resData.reason.length - 1 ? ', ' : ''}
                  </span>
                ))}
            </div>
          </div>
          <div className="flex flex-col justify-start items-center mt-4 w-[100%]  bg-[#f7f4d0] pt-[4px] pb-[4px] pl-2 pr-2 rounded-[4px]">
            <div className="flex justify-between w-[99%] items-center bg-white p-2 pt-1 pb-1">
              <p>Would you like to delete more tasks ?</p>
              <div
                onClick={(e) => {
                  setIsBulk(!isBulk);
                  setSelectItems([]);
                  handleSelectAll(e);
                }}
                className="bg-amber-100 p-2 pt-1 pb-1 rounded-[5px] flex justify-center items-center gap-2 cursor-pointer">
                Bulk Delete
                <input
                  type="checkbox"
                  checked={isBulk}
                  readOnly
                  className="outline-none border-none"
                />
              </div>
            </div>
            {isBulk && (
              <div className="pl-[10px] w-[100%] pr-[19px] mt-2 mb-2 max-h-[14rem] overflow-auto">
                {tasks &&
                  tasks?.map((c, index) => (
                    <div key={index} className="flex justify-between items-center text-[#5b5b5b]">
                      {index + 1}. {c.name}
                      <input
                        className="outline-none border-none"
                        type="checkbox"
                        checked={selectItems.includes(c.id)}
                      />
                    </div>
                  ))}
              </div>
            )}
          </div>

          <div className="w-full flex justify-end items-center space-x-4 mt-8">
            <Button
              type="reset"
              onClick={() => {
                setCanDelete(null);
                setIsBulk(false);
                setSelectItems([]);
              }}
              displayType="secondary">
              Cancel
            </Button>
            <Button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                HandleBulkDelete(selectItems);
              }}
              disabled={isSubmitting || selectItems.length === 0}
              displayType="primary-red">
              Delete
            </Button>
          </div>
        </Modal>
      )}

      {canDelete === 'yes' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={'Confirmation'}
          onClose={() => {
            setCanDelete(null);
            setSelectedIds([]);
          }}
          width={45}>
          <DeleteConfirmationModal
            name={resData.name}
            title={'task'}
            onClose={() => setCanDelete(null)}
            data={tasks}
            type={'commonLiveTask'}
            setCanDelete={setCanDelete}
            onDeleteClick={HandleDelete}
            setSelectedIds={setSelectedIds}
            selectedIds={selectedIds}
          />
        </Modal>
      )}

      <div
        className={`flex justify-between items-center gap-2 fixed  z-30 border  bg-white px-6 py-3 pb-6 mt-[-0.86rem]   transition-all duration-300 ease-in-out ${collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
          }`}>
        <form
          onSubmit={handleSubmit(HandleCreate)}
          className="flex justify-between items-end w-[100%]">
          <div className="flex w-[min(760px,80%)] min-w-0 flex-wrap items-end gap-3">
            <div className="min-w-[220px] max-w-[300px] flex-[1.3]">
              <FormInput
                width={100}
                label={'Project'}
                register={register}
                register_key={'project'}
                isRequired={true}
                type={'dropdown'}
                options={[
                  { label: 'Select Project', value: '', disabled: true, selected: true }, // Add the "Select Project" option first
                  ...projectsForDropdown
                ]}
                validation={{ required: 'Project is required' }}
                errors={errors}
              />
            </div>

            <div className="min-w-[140px] max-w-[200px] flex-1">
              <FormInput
                width={100}
                label={'Block'}
                register={register}
                register_key={'block'}
                isRequired={true}
                type={'dropdown'}
                options={[
                  { label: 'Select Block', value: '', disabled: true, selected: true }, // Add the "Select Project" option first
                  ...transformedDataBlocks
                ]}
                validation={{ required: 'Block is required' }}
                errors={errors}
              />
            </div>

            {tasks && tasks.length < 1 && (
              <>
                <div className="min-w-[180px] max-w-[260px] flex-1">
                  <FormInput
                    width={100}
                    label={'Task Template'}
                    register={register}
                    register_key={'template_name'}
                    isRequired={true}
                    type={'dropdown'}
                    options={[
                      { label: 'Select Task Template', value: '', disabled: true, selected: true },
                      ...transformedDataTaskTemplates
                    ]}
                    validation={{ required: 'Task template is required' }}
                    errors={errors}
                  />
                </div>

                <div className="min-w-[120px] max-w-[160px]">
                  <FormInput
                    width={100}
                    label={'No. of Sections'}
                  register={register}
                  register_key={'sections'}
                  isRequired={true}
                  type={'text'}
                  onType={(value) => {
                    if (value === '') {
                      setValue('sections', '');
                      return;
                    }

                    const cleaned = value.replace(/[^0-9]/g, '');
                    setValue('sections', cleaned);
                  }}
                  validation={{ required: 'No. of Sections is required' }}
                  errors={errors}
                />
                </div>
              </>
            )}
          </div>

          <div className="flex justify-end items-center w-[20%] gap-4">
            {tasks && tasks.length < 1 && (
              <Button
                customStyle={{
                  height: '2.5rem',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
                disabled={isSubmitting}
                type="submit">
                Create
              </Button>
            )}
            {!hidePreviewTable && (
              <div className="flex justify-center gap-4">
                {tasks && tasks?.length > 0 && (
                  <Button
                    type={'button'}
                    customStyle={{
                      paddingLeft: '1rem',
                      paddingRight: '1rem',
                      whiteSpace: 'nowrap'
                    }}
                    onClick={handleBulkCompleteClick}>
                    Mark as Complete
                  </Button>
                )}

                <Button
                  type={'button'}
                  disabled={!hidePreviewBtn}
                  customStyle={{ paddingLeft: '3rem', paddingRight: '3rem' }}
                  onClick={HandleSavePreview}>
                  Save
                </Button>

                {tasks && tasks?.length > 0 && (
                  <Button
                    type={'button'}
                    displayType={'secondary-red'}
                    customStyle={{ paddingLeft: '3rem', paddingRight: '3rem' }}
                    onClick={HandleCancelCreatedLiveTask}>
                    Cancel
                  </Button>
                )}
              </div>
            )}{' '}
          </div>
        </form>

        {hidePreviewTable && (
          <div className="flex gap-4">
            <Button
              onClick={() => setIsBulkActionModalOpen(true)}
              customStyle={{ paddingLeft: ' 1rem', paddingRight: '1rem', whiteSpace: 'nowrap' }}>
              Bulk Actions
            </Button>
            <Button
              customStyle={{ paddingLeft: '1rem', paddingRight: '1rem', whiteSpace: 'nowrap' }}
              onClick={() =>
                navigate('/builder/operations/tasks/ganttChart', {
                  state: { title: 'Group Tasks', data: tasks }
                })
              }>
              Gantt Chart
            </Button>
          </div>
        )}
      </div>

      {!hidePreviewTable && (
        <div className={`${'pt-[7rem]'}`}>
          <div className="shadow overflow-auto rounded-lg">
            <InfiniteScroll
              dataLength={allTasks.length}
              next={loadMore}
              hasMore={hasNextPage}
              loader={
                <div className="flex justify-center items-center py-4">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                  <span className="ml-2 text-gray-600">Loading more tasks...</span>
                </div>
              }
              endMessage={
                <div className="flex justify-center items-center py-4">
                  <p className="text-gray-500">No more tasks to load</p>
                </div>
              }
              style={{ overflow: 'visible' }}>
              <table className="min-w-full rounded-t-xl text-left   shadow">
                <thead className=" bg-gray-200 !text-gray-600 w-full ">
                  <tr className="font-normal h-[3rem] w-full">
                    <th className="px-4 py-2 border-b font-normal ">ID</th>
                    <th className="px-4 py-2 border-b font-normal">Task Name</th>
                    <th className="px-4 py-2 border-b font-normal">Planned Start Date</th>
                    <th className="px-4 py-2 border-b font-normal">Planned End Date</th>
                    <th className="px-4 py-2 border-b relative font-normal">
                      <div className="flex gap-2 justify-center items-center">
                        Assign Employee
                        {tasks && tasks?.length > 0 && (
                          <CirclePlus
                            height={15}
                            width={15}
                            className="cursor-pointer"
                            onClick={(e) => {
                              UsersMutation();
                              fetchWorkTypes(); // Call getAllWorkTypes when architect is clicked

                              setIsEngineerBulkAssignModalOpen(true);
                              e.stopPropagation();
                            }}
                          />
                        )}
                      </div>
                    </th>
                    <th className="px-4 py-2 border-b font-normal">
                      <div className="flex gap-2 justify-center items-center">
                        Assign Contractor
                        {tasks && tasks?.length > 0 && (
                          <CirclePlus
                            height={15}
                            width={15}
                            className="cursor-pointer"
                            onClick={(e) => {
                              ContractorsMutation();
                              fetchWorkTypes();
                              // Fetch units data and open modal when data is ready
                              refetchUnitsAndOpenModal();
                              e.stopPropagation();
                            }}
                          />
                        )}
                      </div>
                    </th>
                    <th className="px-4 py-2 border-b font-normal">
                      <div className="flex gap-2 justify-center items-center">
                        Assign Architect
                        {tasks && tasks?.length > 0 && (
                          <CirclePlus
                            height={15}
                            width={15}
                            className="cursor-pointer"
                            onClick={(e) => {
                              handleImageClick(null, 'architect');
                              e.stopPropagation();
                            }}
                          />
                        )}
                      </div>
                    </th>
                    <th className="px-4 py-2 border-b font-normal">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {tasks && tasks?.length > 0 ? (
                    tasks?.map((task, index) => {
                      return (
                        <React.Fragment key={task?.id}>
                          <tr
                            className="border-b hover:bg-gray-50 bg-white h-[3.5rem]"
                            onClick={() => {
                              setApiType('group');
                              setSelectedTaskId(task?.id);
                              toggleDrawer('right', true);
                            }}>
                            <td className="px-4 py-2 text-blue-600 underline cursor-pointer">
                              {index + 1}
                            </td>
                            <td className="px-4 py-2">{task?.name}</td>
                            <td className="px-4 py-2">
                              {task.status !== 'Completed' &&
                                (task.planned_start_date ? (
                                  formatDate(task?.planned_start_date)
                                ) : task?.dependencies?.length > 0 &&
                                  !task?.dependencies?.some(
                                    (item) => item?.dependency?.status === 'Completed'
                                  ) ? (
                                  '--'
                                ) : (
                                  <img
                                    className="cursor-pointer"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDateClick(task?.id, 'start');
                                    }}
                                    src={CalenderIcon}
                                    alt="calenderIcon"
                                  />
                                ))}
                            </td>

                            <td className="px-4 py-2">
                              {task?.planned_end_date ? formatDate(task?.planned_end_date) : '--'}
                            </td>

                            <td className="px-4 py-2">
                              <div className="flex items-center justify-center w-full relative">
                                {task?.engineerLiveTaskMapping?.length > 0 ? (
                                  <div
                                    className="flex -space-x-3"
                                    onClick={(e) => {
                                      handleImageClick(task?.id, 'engineer');
                                      setUnique(false);
                                      e.stopPropagation();
                                    }}>
                                    {task?.engineerLiveTaskMapping?.map((engineer, index) => (
                                      <div
                                        key={engineer.id}
                                        className={`w-6 h-6 rounded-full ${getUserColor(engineer?.user?.id)} text-white flex items-center justify-center text-[0.8rem] font-semibold border-2 border-white leading-none cursor-pointer`}
                                        style={{
                                          zIndex: task.engineerLiveTaskMapping.length - index
                                        }}>
                                        {engineer?.user?.name?.charAt(0).toUpperCase()}
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  <img
                                    src={DP}
                                    alt=""
                                    className="cursor-pointer"
                                    onClick={(e) => {
                                      handleImageClick(task?.id, 'engineer');
                                      setUnique(false);
                                      e.stopPropagation();
                                    }}
                                  />
                                )}
                              </div>
                            </td>

                            <td className="px-4 py-2">
                              <div className="flex items-center justify-center w-full relative">
                                {task?.spLiveTaskMapping?.some(
                                  (contractor) =>
                                    contractor?.user?.serviceProvider?.category_id === 1
                                ) ? (
                                  <div
                                    className="flex -space-x-3"
                                    onClick={(e) => {
                                      handleImageClick(task?.id, 'contractor');
                                      setUnique(false);
                                      e.stopPropagation();
                                    }}>
                                    {task.spLiveTaskMapping
                                      .filter(
                                        (contractor) =>
                                          contractor?.user?.serviceProvider?.category_id === 1
                                      )
                                      ?.map((contractor, index) => (
                                        <div
                                          key={contractor.id}
                                          className={`w-6 h-6 rounded-full ${getUserColor(contractor?.user?.id)} text-white flex items-center justify-center text-[0.8rem] font-semibold border-2 border-white leading-none cursor-pointer`}
                                          style={{ zIndex: task.spLiveTaskMapping.length - index }}>
                                          {contractor?.user?.name?.charAt(0).toUpperCase()}
                                        </div>
                                      ))}
                                  </div>
                                ) : (
                                  <img
                                    src={DP}
                                    alt=""
                                    className="cursor-pointer"
                                    onClick={(e) => {
                                      handleImageClick(task?.id, 'contractor');
                                      setUnique(false);
                                      e.stopPropagation();
                                    }}
                                  />
                                )}
                              </div>
                            </td>
                            <td className="px-4 py-2">
                              <div className="flex items-center justify-center w-full relative">
                                {task?.drawing_required ? (
                                  task.architectLiveTaskMapping?.some(
                                    (architect) =>
                                      architect?.user?.serviceProvider?.category_id === 2
                                  ) ? (
                                    <div
                                      className="flex -space-x-3"
                                      onClick={(e) => {
                                        handleImageClick(task?.id, 'architect');
                                        setModalData(AllArchitect.data);
                                        e.stopPropagation();
                                        setUnique(false);
                                      }}>
                                      {task.architectLiveTaskMapping
                                        .filter(
                                          (architect) =>
                                            architect?.user?.serviceProvider?.category_id === 2
                                        )
                                        ?.map((architect, index) => (
                                          <div
                                            key={architect.id}
                                            className={`w-6 h-6 rounded-full ${getUserColor(architect?.user?.id)} text-white flex items-center justify-center text-[0.8rem] font-semibold border-2 border-white leading-none cursor-pointer`}
                                            style={{
                                              zIndex: task.architectLiveTaskMapping.length - index
                                            }}>
                                            {architect?.user?.name?.charAt(0).toUpperCase()}
                                          </div>
                                        ))}
                                    </div>
                                  ) : (
                                    <img
                                      src={DP}
                                      alt=""
                                      className="cursor-pointer"
                                      onClick={(e) => {
                                        handleImageClick(task?.id, 'architect');
                                        setModalData(AllArchitect.data);
                                        setUnique(false);
                                        e.stopPropagation();
                                      }}
                                    />
                                  )
                                ) : (
                                  'N/A'
                                )}
                              </div>
                            </td>

                            <td className="px-4 py-2">
                              <TableData data={task.status} />
                            </td>

                            {/* <td className="px-4 py-2">
                        {Number(task.material_budget) + Number(task.labour_budget) || '---'}
                      </td>
                      <td className="px-4 py-2">
                        {task.materialTaskMapping?.length > 0
                          ? task.materialTaskMapping.map((item) => item.name).join(', ')
                          : '---'}
                      </td> */}
                          </tr>
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={9} className="text-center py-7">
                        <div className="flex flex-col items-center justify-center">
                          <img
                            src={noDataIcon}
                            alt="No Data"
                            className="w-[25rem] h-[20rem] object-cover"
                          />
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </InfiniteScroll>

            {/* <PaginationComponent
          page={currentPage}
          totalPages={Math.ceil(tasks?.length / itemsPerPage)}
          onPageChange={handlePageChange}
          isFetching={isFetching}
        /> */}
          </div>
        </div>
      )}
      {hidePreviewTable && (
        <div className="pt-[7rem]">
          <div className="shadow overflow-auto rounded-lg">
            <InfiniteScroll
              dataLength={allTasks.length}
              next={loadMore}
              hasMore={hasNextPage}
              loader={
                <div className="flex justify-center items-center py-4">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                  <span className="ml-2 text-gray-600">Loading more tasks...</span>
                </div>
              }
              endMessage={
                <div className="flex justify-center items-center py-4">
                  <p className="text-gray-500">No more tasks to load</p>
                </div>
              }
              style={{ overflow: 'visible' }}>
              <table className="min-w-full rounded-t-xl text-left">
                <thead className=" bg-gray-200 !text-gray-600 ">
                  <tr className="font-normal h-[3rem]">
                    <th className="px-3 py-2 border-b font-normal ">ID</th>
                    <th className="px-3 py-2 border-b font-normal">WorkType</th>
                    <th className="px-3 py-2 border-b font-normal">Task Name</th>
                    <th className="px-3 py-2 border-b font-normal">Planned Start Date</th>
                    <th className="px-3 py-2 border-b font-normal">Planned End Date</th>
                    <th className="px-3 py-2 border-b font-normal">Actual Start Date</th>
                    <th className="px-3 py-2 border-b font-normal">Actual End Date</th>
                    <th className="px-3 py-2 border-b font-normal">Status</th>
                    <th className="px-3 py-2 border-b font-normal">Delay</th>
                    <th className="px-3 py-2 border-b font-normal">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    let rowIndex = 1; // Start the index from 1

                    return formatted?.map((task) => {
                      const rows = [];

                      // Main task row
                      rows.push(
                        <tr
                          key={task?.id}
                          className="border-b bg-white h-[3.5rem]"
                          onClick={() => {
                            setApiType('group');
                            setSelectedTaskId(task?.id);
                            toggleDrawer('right', true);
                          }}>
                          <td className="px-4 py-2 text-blue-600 underline cursor-pointer">
                            {rowIndex++}
                          </td>
                          <td className="px-4 py-2 cursor-pointer">{task.workType}</td>
                          <td className="px-4 py-2">{task.name}</td>
                          <td className="px-4 py-2">{formatDate(task.planned_start_date)}</td>
                          <td className="px-4 py-2">{formatDate(task.planned_end_date)}</td>
                          <td className="px-4 py-2">{formatDate(task.actual_start_date)}</td>
                          <td className="px-4 py-2">{formatDate(task.actual_end_date)}</td>
                          <td className="px-4 py-2">{task.status}</td>
                          <td className="px-4 py-2 text-red-600">{calculateDelay(task)}</td>
                          <td className="px-4 py-[1.45rem] flex space-x-2 items-center text-gray-600">
                            {task.status !== 'Completed' && (
                              <Pencil
                                className="w-4 h-4 cursor-pointer hover:text-blue-500"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleOnEdit(task.id);
                                  setTaskPositionType('First');
                                }}
                              />
                            )}
                            <div className="relative group">
                              <Plus
                                className="w-4 h-4 cursor-pointer hover:text-purple-500"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setIsOpenAddEditModal(true);
                                  setModalType('Add');
                                  setPreviousTask(task);
                                  setTaskPositionType('First');
                                }}
                              />
                              <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 whitespace-nowrap text-xs bg-black text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                                Add new task
                              </div>
                            </div>
                            <Trash
                              className="w-4 h-4 cursor-pointer hover:text-red-500"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleCheckDelete(task.id);
                              }}
                            />
                          </td>
                        </tr>
                      );

                      // Subtasks (Others)
                      task?.Others.forEach((sub) => {
                        rows?.push(
                          <tr
                            key={sub.id}
                            className="border-b bg-gray-50 h-[3.5rem]"
                            onClick={() => {
                              setApiType('group');
                              setSelectedTaskId(sub.id);
                              toggleDrawer('right', true);
                            }}>
                            <td className="px-4 py-2 text-blue-600 underline cursor-pointer">
                              {rowIndex++}
                            </td>
                            <td className="px-4 py-2 text-blue-600 underline cursor-pointer"></td>
                            <td className="px-4 py-2">{sub.name}</td>
                            <td className="px-4 py-2">{formatDate(sub.planned_start_date)}</td>
                            <td className="px-4 py-2">{formatDate(sub.planned_end_date)}</td>
                            <td className="px-4 py-2">{formatDate(sub.actual_start_date)}</td>
                            <td className="px-4 py-2">{formatDate(sub.actual_end_date)}</td>
                            <td className="px-4 py-2">{sub.status}</td>
                            <td className="px-4 py-2 text-red-600">{calculateDelay(sub)}</td>
                            <td className="px-4 py-[1.45rem] flex space-x-2 items-center text-gray-600">
                              {sub.status !== 'Completed' && (
                                <Pencil
                                  className="w-4 h-4 cursor-pointer hover:text-blue-500"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleOnEdit(sub.id);
                                    setTaskPositionType('Other');
                                  }}
                                />
                              )}
                              <div className="relative group">
                                <Plus
                                  className="w-4 h-4 cursor-pointer hover:text-purple-500"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setIsOpenAddEditModal(true);
                                    setModalType('Add');
                                    setPreviousTask(sub);
                                    setTaskPositionType('Other');
                                  }}
                                />
                                <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 whitespace-nowrap text-xs bg-black text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                                  Add new task
                                </div>
                              </div>
                              <Trash
                                className="w-4 h-4 cursor-pointer hover:text-red-500"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleCheckDelete(sub.id);
                                }}
                              />
                            </td>
                          </tr>
                        );
                      });

                      return rows;
                    });
                  })()}
                </tbody>
              </table>
            </InfiniteScroll>
          </div>
        </div>
      )}

      {/* Bulk Complete Modal */}
      {isBulkCompleteModalOpen && (
        <BulkCompleteModal
          isOpen={isBulkCompleteModalOpen}
          onClose={() => setIsBulkCompleteModalOpen(false)}
          tasks={tasks}
          workTypes={transformedDataWorkTypes}
          onBulkComplete={handleBulkCompleteSubmit}
          isSubmitting={isSubmitting}
          showWorktypeSelection={true}
          title="Mark Tasks as Complete"
        />
      )}

      <SwipeableDrawer
        anchor={'right'}
        open={state['right']}
        onClose={() => {
          toggleDrawer('right', false);
          setSelectedTaskId(null);
        }}
        onOpen={() => () => toggleDrawer('right', true)}>
        <TaskDetailsPage
          apiType={apiType}
          taskID={selectedTaskId}
          drawerState={state?.right}
          callApi={refetchGroupLiveTask}
        />
      </SwipeableDrawer>

      {/* Engineer Bulk Assignment Modal */}
      <BulkEngineerAssignmentModal
        isOpen={isEngineerBulkAssignModalOpen}
        onClose={() => setIsEngineerBulkAssignModalOpen(false)}
        workTypes={transformedDataWorkTypes || []}
        allUsers={AllUsers}
        tasks={tasks}
        onAssignEngineers={handleBulkEngineerAssignment}
        isSubmitting={isSubmitting}
        getUserColor={getUserColor}
        setIsSubmitting={setIsSubmitting}
      />

      {/* Contractor Bulk Assignment Modal */}
      <BulkContractorAssignmentModal
        isOpen={isContractorBulkAssignModalOpen}
        onClose={() => setIsContractorBulkAssignModalOpen(false)}
        workTypes={transformedDataWorkTypes || []}
        allContractors={AllContractors?.data || []}
        tasks={tasks}
        onAssignContractors={handleBulkContractorAssignment}
        isSubmitting={isSubmitting}
        getUserColor={getUserColor}
        setIsSubmitting={setIsSubmitting}
        levels={levels || []}
        units={transformedDataUnits || []}
        refetchContractors={ContractorsMutation}
      />

      {/* Bulk Action Modal */}
      {isBulkActionModalOpen && (
        <BulkActionModal
          isOpen={isBulkActionModalOpen}
          onClose={() => setIsBulkActionModalOpen(false)}
          onActionSelect={(actionType) => {
            setIsBulkActionModalOpen(false);

            switch (actionType) {
              case 'assign_employee':
                UsersMutation();
                fetchWorkTypes();
                setIsEngineerBulkAssignModalOpen(true);
                break;
              case 'assign_contractor':
                ContractorsMutation();
                fetchWorkTypes();
                // Fetch units data and open modal when data is ready
                refetchUnitsAndOpenModal();
                break;
              case 'assign_architect':
                handleImageClick(null, 'architect');
                break;
              case 'complete_task':
                fetchWorkTypes();
                setIsBulkCompleteModalOpen(true);
                break;
              default:
                break;
            }
          }}
          isSubmitting={isSubmitting}
        />
      )}

      {/* Add Service Provider Modal */}
      {showAddSPModal && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={60}
          name="Add Service Provider"
          onClose={() => setShowAddSPModal(false)}>
          <AddServiceProvider
            isSubmitting={isSubmittingSP}
            modalType="Add"
            onSubmit={handleCreateServiceProvider}
            onClose={() => setShowAddSPModal(false)}
            selectedServiceProvider={null}
            setSelectedServiceProvider={() => { }}
            setModalType={() => { }}
            setOpenAddUser={setShowAddSPModal}
            OpenAddUser={showAddSPModal}
            refetchServiceProviders={() => { }}
          />
        </Modal>
      )}
    </div>
  );
};

export default GroupLiveTasks;
